import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  PayrollSelfOnboardingInput,
  PayrollSelfOnboardingGraphQLRequest,
  PayrollSelfOnboardingResponse,
} from '../types';

const payrollSelfOnboardingMutation = gql`
  mutation PayrollSelfOnboarding($input: PayrollSelfOnboardingInput!) {
    payrollSelfOnboarding(input: $input) {
      code
      success
      message
      data {
        peopleId
        updatedFields
      }
    }
  }
`;

export const selfOnboarding = (input: PayrollSelfOnboardingInput) => {
  return graphQLApi<PayrollSelfOnboardingResponse, PayrollSelfOnboardingGraphQLRequest>({
    query: payrollSelfOnboardingMutation,
    queryVariables: { input },
  });
};
